<template>
  <main class="landing-page">
    <slot />
  </main>
</template>

<style lang="scss" scoped>
    .landing-page{
        font-family: $primary-font-light;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
</style>
